@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.float-textarea {
  position: relative;
  height: 100%;
  padding: 0;
  transition: all 300ms ease;
  background: @float-text-area--background-color;
  border-radius: 4px;
  border: 1px solid @float-text-area--border-color;
  min-height: 100px;
  &:focus-within {
    border-color: @float-text-area--focus-within--border-color;
  }
  &.error {
    border: solid 1px @float-text-area--error--border-color;
  }

  &.disabled {
    > div {
      background-color: @float-text-area--disabled--background-color;
    }
  }

  &.label {
    > textarea {
      top: 18px;
      height: ~'calc(100% - 18px)';
    }
  }
  &.noLabel {
    > textarea {
      top: 5px;
      height: ~'calc(100% - 5px)';
    }
  }

  > textarea {
    bottom: 0;
    left: 0;
    right: 0;
    border: 0;
    resize: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    background: transparent;
    transition: all 300ms ease;
    min-height: 60px;
    padding: 0 5px 0 10px;
    color: @float-text-area--text-color;
    line-height: 20px;
    font-size: 14px;

    &:focus {
      outline: none;
    }
  }
}
